import { globByFullPathname } from '../../lib/content/globs'
import { error } from "@sveltejs/kit"
import { trimEnd } from "../../lib/utils/string.js"

export async function load({ params }) {
	const glob = globByFullPathname.get(trimEnd(params.any, "/"))
	if (!glob) return error(404, `The page "/${params.any}" is not found.`)

	return {
		content: glob.default,
		metadata: glob.metadata
	}
}
